export default __webpack_public_path__ + "static/media/logo.cfc8fac9.png";